<script>
  import Modal from "../../components/Modal.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { createEventDispatcher } from "svelte"
  import Container from "../../components/Container.svelte"

  const dispatch = createEventDispatcher()
  export let cliente

  let isOpenModalCorreos = false
  let correo_tipo = ""
  let correo = ""
  let isSettingCorreo = false

  const handleAgregarCorreo = () => {
    isOpenModalCorreos = true
  }

  const updateCorreoVerificado = async () => {
    if (correo_tipo === "") {
      return
    }

    if (!validarCorreo(correo)) {
      // Validación básica de correo electrónico
      alert("Por favor, ingrese un correo electrónico válido.")
      return
    }

    isSettingCorreo = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateCorreoVerificado",
        id: cliente.id,
        correo,
        tipo: correo_tipo,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      correo_tipo = ""
      correo = ""
      dispatch("update")
      isOpenModalCorreos = false
    } else {
      console.error("Error al actualizar correo verificado:", data.message)
    }
    isSettingCorreo = false
  }

  const validarCorreo = (correo) => {
    // Expresión regular para validar correo electrónico estándar
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(correo)
  }
</script>

<Container>
  <div class="d-flex justify-content-between align-items-center">
    <h6 class="text-start">
      <i class="bi-envelope fg-secondary me-3"></i> Correos verificados
    </h6>
    <button class="btn btn-sm fg-primary" on:click={handleAgregarCorreo}
      ><i class="bi bi-pencil-square"></i></button
    >
  </div>
  <div class="table-responsive">
    <table class="table table-striped table-sm small">
      <tbody>
        <tr>
          <td class="fg-secondary">Principal</td>
          <td>{cliente.correo_principal}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Secundario</td>
          <td>{cliente.correo_secundario}</td>
        </tr>
      </tbody>
    </table>
  </div>
</Container>

<Modal
  isOpen={isOpenModalCorreos}
  on:close={() => (isOpenModalCorreos = false)}
  title="Agregar correo"
>
  <div class="mb-3">
    <label for="tipo" class="form-label">Tipo</label>
    <select
      id="tipo"
      class="form-control form-control-sm"
      bind:value={correo_tipo}
    >
      <option value="">Seleccionar</option>
      <option value="correo_principal">Principal</option>
      <option value="correo_secundario">Secundario</option>
    </select>
  </div>
  <div class="mb-3">
    <label for="correo" class="form-label">Correo</label>
    <input
      type="email"
      id="correo"
      class="form-control form-control-sm"
      bind:value={correo}
      placeholder="Ingrese el correo electrónico"
    />
  </div>
  <div class="mb-3 text-end">
    {#if isSettingCorreo}
      <button class="btn btn-solid theme-primary btn-sm disabled" disabled
        >Agregando...</button
      >
    {:else}
      <button class="btn btn-solid theme-primary btn-sm" on:click={updateCorreoVerificado}
        >Agregar</button
      >
    {/if}
  </div>
</Modal>
